import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import DraftingPage from "../../components/services/2ddrafting/index"
const drafting = () => {
  return (
    <Layout>
      <SEO
        title="2D Drafting Detailing Services in India - Innoway Sytem"
        desc="We can provide documentation and manufacturing needs. In case of a building design, 2D drafting is an essential document to execute the project."
        pathname="/services/2d-drafting/"
        keywords="Machine Drawings ,Assembly Drawings in India,Assembly Drawings in coimbatore"
      />
      <DraftingPage />
    </Layout>
  )
}

export default drafting
